import IsabelPaymentCard from './IsabelPaymentCard';

export default IsabelPaymentCard;
